import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RaffleWinnersContent from "modules/RaffleWinners";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const RaffleWinnersPage: React.FC = () => {
  setTitle("Raffle Winner List");
  return (
    <Auth>
      <Layout>
        <RaffleWinnersContent />
      </Layout>
    </Auth>
  );
};

export default RaffleWinnersPage;
